export const handleConcat = (value, allowedLength = 30) => {
  const valToCheck = String(value);
  if (valToCheck.length > allowedLength) {
    return valToCheck.substring(0, allowedLength) + "...";
  }
  return valToCheck;
};
